import { useState } from "react";
import { ListChecks } from "lucide-react";
import { formatDate } from "../lib/format";
import type { WorkItem } from "../types";
import { Modal } from "./Modal";
import { Surface } from "./Surface";

export function DashboardNeedsCard({ organizationName, items, onComplete, onViewAll }: { organizationName: string; items: WorkItem[]; onComplete(itemId: string): void | Promise<unknown>; onViewAll(): void }) {
  const [pendingItem, setPendingItem] = useState<WorkItem | null>(null);
  const confirmCompletion = async () => {
    if (!pendingItem) return;
    await onComplete(pendingItem.id);
    setPendingItem(null);
  };

  return <>
    <Surface title={`Qué necesitamos de ${organizationName}`} icon={<ListChecks size={18}/>} action={{ label: "Ver todos", onClick: onViewAll }} className="needs-card dashboard-card">
      <div className="needs-scroll checklist">
        {items.length ? items.map((item) => <label key={item.id}>
          <input type="checkbox" checked={false} aria-label={`Entregar ${item.title}`} onChange={() => setPendingItem(item)}/>
          <span title={item.title}>{item.title}</span>
          <time>{formatDate(item.due_date)}</time>
        </label>) : <p className="muted-copy">No hay pendientes para el cliente.</p>}
      </div>
    </Surface>
    <Modal open={Boolean(pendingItem)} title="Marcar pendiente como entregado" onClose={() => setPendingItem(null)}>
      {pendingItem && <div className="confirm-dialog pending-confirmation">
        <p>¿Confirmas que DLR ya entregó este pendiente?</p>
        <strong>{pendingItem.title}</strong>
        <div className="form-actions">
          <button type="button" className="button secondary" onClick={() => setPendingItem(null)}>Cancelar</button>
          <button type="button" className="button primary" onClick={() => void confirmCompletion()}>Marcar como entregado</button>
        </div>
      </div>}
    </Modal>
  </>;
}
